<template>
  <div>
      <div :style="{width: getScreenWidth > 500 ? '70%' : '100%', margin: '0 auto'}">
        <Section1 />
        <Section2 />
        <Section3 />
      </div>
      <Section4 />
      <Section5 />
      <Section6 />
      <div style="margin-top: 40px;">
        &nbsp;
      </div>
      <Section7 />
  </div>
        

</template>

<script>
import Section1 from './Section1'
import Section2 from './Section2'
import Section3 from './Section3'
import Section4 from './Section4'
import Section5 from './Section5'
import Section6 from './Section6'
import Section7 from './Section7'

export default {
  components: {Section1, Section2, Section3, Section4, Section5, Section6, Section7},
  computed: {
    getScreenWidth() {
      return window.screen.width
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Home/Index.vue